function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import { Button, BUTTON_VARIANT } from "#library/components/Button";
import IconPlus from "#library/assets/icons/jds_plus.svg";
import styles from "./CellCTA.module.css";
export var CellCTA = function CellCTA(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: styles["jds-CellCTA"]
  }, /*#__PURE__*/React.createElement(Button, _extends({
    minor: true,
    isFullWidth: true,
    variant: BUTTON_VARIANT.NAKED,
    icon: IconPlus
  }, props)));
};